(() => {
  function getActiveFilterLabel() {
    const params = new URLSearchParams(window.location.search);
    const brand = params.get('filter.p.m.custom.brand');
    const type = params.get('filter.p.product_type');
    return (brand || type || '').replace(/\+/g, ' ');
  }

  function updateCollectionTitle() {
    const label = getActiveFilterLabel();
    const title = document.querySelector('.collection-hero__title');
    if (!title) return;

    const hidden = title.querySelector('.visually-hidden');
    const text = label || window.__collectionTitle || '';
    title.replaceChildren();
    if (hidden) title.appendChild(hidden);
    title.appendChild(document.createTextNode(text));
  }

  function initCollectionTitle() {
    const title = document.querySelector('.collection-hero__title');
    if (title) {
      title.childNodes.forEach((node) => {
        if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
          window.__collectionTitle = node.textContent.trim();
        }
      });
    }

    updateCollectionTitle();

    let lastUrl = location.href;
    new MutationObserver(() => {
      if (location.href === lastUrl) return;

      lastUrl = location.href;
      window.setTimeout(updateCollectionTitle, 100);
    }).observe(document, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionTitle, { once: true });
  } else {
    initCollectionTitle();
  }
})();
